import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { RiArrowRightLine } from "react-icons/ri";
import "./mobilecategorygrid.css";

const PREVIEW_COUNT = 12;

const MobileCategoryGrid = ({ categories }) => {

  const enabledCategories = useMemo(
    () => categories.filter((c) => c.enabled),
    [categories]
  );

  const previewCategories = useMemo(
    () => enabledCategories.slice(0, PREVIEW_COUNT),
    [enabledCategories]
  );

  return (
    <section className="mobile-category-grid">
      <div className="mobile-category-grid-inner">
        {previewCategories.map((item) => (
          <Link
            key={item.slug}
            to={item.url}
            className="mobile-category-card"
          >
            <div className="mobile-category-icon">
              <img src={item.icon} alt={item.name} />
            </div>
            <div className="mobile-category-label">{item.name}</div>
          </Link>
        ))}

        {/* View All Navigation Tile */}
        <Link to="/all-categories" className="mobile-category-card view-all-card">
          <div className="view-all-icon">
            <RiArrowRightLine />
          </div>
          <span>View All</span>
        </Link>
      </div>
    </section>
  );
};

MobileCategoryGrid.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      icon: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
      slug: PropTypes.string.isRequired,
      enabled: PropTypes.bool,
    })
  ).isRequired,
};

export default MobileCategoryGrid;
